(<template>
  <banner :message="bannerMessage"
          class="proweb-info-banner">
    <a v-if="!$isGodmode()"
       :href="prowebUrl"
       class="sk-btn sk-btn--default proweb-info-banner__btn">{{ $gettext('Go to TolkeNett') }}</a>
  </banner>
</template>)

<script>
  import Banner from '@/components/shared_components/banners/Banner';
  import ProwebBannerTextMixin from '@/mixins/ProwebBannerTextMixin';
  import constants from '@/modules/constants';

  // Banner renders its message as HTML, and these texts are typed in by admins
  const escapeHtml = (text) => text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

  export default {
    components: {
      banner: Banner
    },
    mixins: [ProwebBannerTextMixin],
    computed: {
      prowebUrl() { return constants.PROWEB_URL; },
      bannerMessage() {
        const text = this.$isGodmode() ? this.prowebAdminBannerText : this.prowebBuyerBannerText;

        return escapeHtml(text).replace(/\n/g, '<br>');
      }
    }
  };
</script>

<style scoped>
  .proweb-info-banner {
    width: calc(100% - 30px);
    margin: 15px auto 0;
  }

  .proweb-info-banner__btn {
    flex-shrink: 0;
    width: auto;
    margin-left: auto;
    padding: 0 15px;
  }

  @media (max-width: 767px) {
    .proweb-info-banner {
      width: 100%;
    }
  }

  @media (max-width: 550px) {
    .proweb-info-banner__btn {
      margin: 10px 0 0;
    }
  }
</style>
